











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {CargaTransfolha} from '@/model/resource/CargaTransfolha'
import {CargaTransfolhaCollection} from '@/model/collection/CargaTransfolhaCollection'
import {ListCargaTransfolhaSchema} from '@/schema/resource/CargaTransfolha/ListCargaTransfolhaSchema'
import {CsvCargaTransfolhaSchema} from '@/schema/resource/CargaTransfolha/CsvCargaTransfolhaSchema'

@Component
export default class ListCargaTransfolhaView extends Mixins(MixinQueryRouter) {
  schema = new ListCargaTransfolhaSchema()
  collection = new CargaTransfolhaCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: CargaTransfolha) {
    Helper.pushByName('editCargaTransfolha', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new CargaTransfolhaCollection().clearFilters().addFilter(params)

    await csv.listCsvCargaTransfolha()
    new CsvCargaTransfolhaSchema().downloadCsv(csv.all())
  }
}
